import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchMarriageNonResidentDetailNotificationsShared from 'shell/components/shared/research-notifications/research-marriage-non-resident/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface ResearchMarriageDetailNotificationsCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
  items?: BreadcrumbItem[];
}

const ResearchMarriageNonResidentDetailNotificationsCivilStatusShared = ({
  scope,
  isOther,
  items,
}: ResearchMarriageDetailNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  return (
    <Fragment>
      <ResearchMarriageNonResidentDetailNotificationsShared
        goBackUrl={`${goBackUrl}/matrimonio/non-residenti`}
        editSipoUrl={`${goBackUrl}/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR/persona-sipo`}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isOther={isOther}
      />
    </Fragment>
  );
};

ResearchMarriageNonResidentDetailNotificationsCivilStatusShared.displayName =
  'Research Marriage Detail Notifications CivilStatusShared component';

export default ResearchMarriageNonResidentDetailNotificationsCivilStatusShared;
